import React, { useState, useEffect } from "react";
import {
  getFirestore,
  collection,
  getDocs,
  query,
  orderBy
} from "firebase/firestore";
import "./Modals.css";

const PracticeExams = ({ selectedClassId, selectedUnitId, selectedUnitName, userId }) => {
  const [showOverlay, setShowOverlay] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [currentQuestion, setCurrentQuestion] = useState(null);
  const [message, setMessage] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);


  // lock page scroll while overlay is open
  useEffect(() => {
    document.body.style.overflow = showOverlay ? "hidden" : "";
    return () => (document.body.style.overflow = "");
  }, [showOverlay]);

  // fetch exam questions from Firestore
    // fetch exam questions from Firestore
    useEffect(() => {
        const fetchQuestions = async () => {
            if (!userId || !selectedClassId || !selectedUnitId) return;

            try {
            const db = getFirestore();
            const examRef = collection(
                db,
                "Users",
                userId,
                "Classes",
                selectedClassId,
                "Units",
                selectedUnitId,
                "ExamQuestions"
            );

            const q = query(examRef, orderBy("createdAt"));
            const snapshot = await getDocs(q);

            const data = snapshot.docs.map((doc) => {
                const d = doc.data();

                // Ensure options is an array
                let opts = Array.isArray(d.options) ? [...d.options] : [];

                // Add the correct answer if it's not already in options
                if (d.answer && !opts.includes(d.answer)) {
                opts.push(d.answer);
                }

                // Shuffle the array (randomize order)
                for (let i = opts.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [opts[i], opts[j]] = [opts[j], opts[i]];
                }

                return {
                id: doc.id,
                ...d,

                options: opts,
                };
            });

            setQuestions(data);
            setCurrentIndex(0);
            setCurrentQuestion(data.length > 0 ? data[0] : null);
            } catch (err) {
            console.error("🔥 Error fetching exam questions:", err);
            }
        };

        fetchQuestions();
    }, [userId, selectedClassId, selectedUnitId]);

 



        
  return (
    <>
      <div
        className="section-card"
        onClick={() => {
          if (!selectedClassId || !selectedUnitId) {
            alert("Please select a class and unit first.");
            return;
          }
          setShowOverlay(true);
        }}
      >
        <h2>Practice Exams</h2>
        <p>
          Practice Exams for {selectedUnitName || "no unit selected"}
        </p>
      </div>

      {showOverlay && (
        <div className="flashcard-fullscreen">
          <button
            className="flashcard-close"
            onClick={(e) => {
              e.stopPropagation();
              setShowOverlay(false);
              setSelectedOption(null);
            }}
          >
            ×
          </button>

          <div className="flashcard-header">
            <h2>
              {currentQuestion ? currentQuestion.question : "No questions found"}
            </h2>
          </div>

        <div className="flashcard-body">
            {currentQuestion && currentQuestion.options ? (
                <div className="options-container">
                {currentQuestion.options.map((option, idx) => (
                    <div
                    key={idx}
                    className={`option-row ${
                        selectedOption === idx ? "selected" : ""
                    }`}
                    onClick={() => setSelectedOption(idx)}
                    >
                    <span className="option-circle" />
                    <span className="option-text">{option}</span>
                    </div>
                ))}
                </div>
            ) : (
                <p className="flashcard-prompt">No more questions.</p>
            )}

            {/* Correct/Incorrect message */}
            {message && currentQuestion && (
                <p style={{ marginTop: "20px", fontWeight: "bold" }}>{message}</p>
            )}
        </div>



        <button
            className="exam-enter-btn"
            onClick={(e) => {
                e.stopPropagation();
                if (selectedOption === null) {
                setMessage("⚠️ Please select an option first.");
                return;
                }

                const chosen = currentQuestion.options[selectedOption];
                const isCorrect = chosen === currentQuestion.answer;

                setMessage(isCorrect ? "✅ Correct!" : "❌ Incorrect");

                // Move to next question after short delay
                setTimeout(() => {
                const nextIndex = currentIndex + 1;
                if (nextIndex < questions.length) {
                    setCurrentIndex(nextIndex);
                    setCurrentQuestion(questions[nextIndex]);
                    setSelectedOption(null);
                    setMessage(""); // clear old message
                } else {
                    // ✅ Clear current question so UI shows "No more questions"
                    setCurrentQuestion(null);
                    setMessage("🎉 No more questions");
                }
                }, 1000);
            }}
            >
            Enter
        </button>


        </div>
      )}
    </>
  );
};

export default PracticeExams;
